import { combineReducers } from 'redux';

import api from './ApiReducer';
import assessment from './AssessmentReducer';
import backgroundAudio from './BackgroundAudioReducer';
import branchRule from './BranchRuleReducer';
import cacheStatus from './CacheStatusReducer';
import correctResponses from './CorrectResponsesReducer';
import currentlyShown from './CurrentlyShownReducer';
import delivering from './DeliveringReducer';
import deliveryDetails from './DeliveryDetailsReducer';
import idverification from './IdVerificationReducer';
import interactionVisibility from './InteractionVisibilityReducer';
import itemFlag from './ItemFlagReducer';
import livestream from './LivestreamReducer';
import mediaResources from './MediaResourcesReducer';
import messages from './MessagesReducer';
import parentTest from './ParentTestReducer';
import pendingAssessments from './PendingAssessmentsReducer';
import pciRuntimeState from './PciRuntimeStateReducer';
import presignedUrls from './PresignedUrlsReducer';
import questionSelection from './QuestionSelectionReducer';
import readinessCheck from './ReadinessCheckReducer';
import testQuestions from './TestQuestionsReducer';
import remoteOralExam from './RemoteOralExamReducer';
import response from './ResponseReducer';
import responseStatus from './ResponseStatusReducer';
import result from './ResultReducer';
import session from './SessionReducer';
import settings from './SettingsReducer';
import snapshots from './SnapshotsReducer';
import stimulusHighlights from './StimulusHighlightsReducer';
import studentHighlights from './StudentHighlightsReducer';
import textToSpeech from './TextToSpeechReducer';
import time from './TimeReducer';
import toc from './TocReducer';
import ui from './UIReducer';
import uploadToken from './UploadTokenReducer';
import visitedQuestions from './VisitedQuestionsReducer';
import progress from './ProgressReducer';
import cat from './CatReducer';
import drawing from './DrawingReducer';

import { types } from '../actions/RootActions';

const appReducer = combineReducers({
    api,
    assessment,
    backgroundAudio,
    branchRule,
    cacheStatus,
    correctResponses,
    currentlyShown,
    delivering,
    deliveryDetails,
    idverification,
    interactionVisibility,
    itemFlag,
    livestream,
    mediaResources,
    messages,
    parentTest,
    pendingAssessments,
    pciRuntimeState,
    presignedUrls,
    questionSelection,
    readinessCheck,
    remoteOralExam,
    response,
    responseStatus,
    result,
    session,
    settings,
    snapshots,
    stimulusHighlights,
    studentHighlights,
    testQuestions,
    textToSpeech,
    time,
    toc,
    ui,
    uploadToken,
    visitedQuestions,
    progress,
    cat,
    drawing,
});

const rootReducer = (state, action) => {
    if (action.type === types.ROOT_RESET) {
        state = undefined; // eslint-disable-line no-param-reassign
    }

    return appReducer(state, action);
};

export default rootReducer;
